<template>
    <div class="G-force" >
        <div class="circle --1">
            <div class="text top">5G</div>
            <div class="text right">5G</div>
            <div class="text current">Current: {{ calculatedGforce }}G</div>
            <div class="text bot">5G</div>
            <div class="text left">5G</div>
        </div>
        <div class="circle --2" />
        <div class="circle --3" />
        <div class="circle --4" />
        <div class="circle --5" >
          <div class="dot" :style="GforeStyle" />
        </div>
        <div class="scale" />
        <div class="scale v" />
    </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  XCoord: {
    type: Number,
    required: true,
  },
  YCoord: {
    type: Number,
    required: true,
  }
});

const calculatedGforce = computed(()=>{
  let gforce = 0;
  if(props.XCoord == 0){
    gforce = Math.abs(props.YCoord);
  } else if(props.YCoord == 0){
    gforce = Math.abs(props.XCoord);
  } else {
    gforce = Math.sqrt(props.XCoord**2 + props.YCoord**2)
  }

  return parseFloat(gforce).toFixed(2)
})

const GforeStyle= computed(() => {
  let localX = props.XCoord * 20;  
  let localY = props.YCoord * 20;

  let relativeRadius = Math.sqrt(localX**2 + localY**2);
  while(relativeRadius > 100) {
    if(localX - 0.05 > 0) {
      localX -= 0.05;
    } else if(localX + 0.05 < 0) {
      localX += 0.05;
    }

    if(localY -0.05 > 0) {
      localY -= 0.05;
    } else if(localY + 0.05 < 0) {
      localY += 0.05;
    }

    relativeRadius = Math.sqrt(localX**2 + localY **2);
  }

  return {
    left: 7.5 + (localX) + "px",
    top: 7.5 + (-localY) + "px"
  }
});

</script>

